import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankPayment, CommerceDetailed, Payment, Transaction } from 'src/app/shared/models/models';
import { DataService } from 'src/app/shared/services/data.service';
import { error_toast, success_toast } from 'src/app/utilities/toaster/toaster.utilities';
import { export_text_file, export_xlsx_file, pad_zeroes, sum, getDates, generateRandomString } from 'src/app/utilities/utilities';
import { State } from 'src/app/shared/state.shared';

import '../../../utilities/extensions';


@Component({
   selector: 'app-point-of-sale',
   templateUrl: './point-of-sale.component.html',
   styleUrls: ['./point-of-sale.component.less']
})
export class PointOfSaleComponent {
   commerce = <CommerceDetailed>{
      id: 0,
      code: "",
      name: "",
      address: "",
      type: "",
      enabled: null,
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      contact_mobile_phone: "",
      agency: null,
      intermediary: null,
      agency_invoicers: null,
      document: "",
      bank_account: "",
      account_type: "",
      legal_status: "",
      balance: 0,
      use_balance: false,
      ind_chain: false,
   };

   start_date: string | Date;
   end_date: string | Date;
   today: string | Date;

   working = false;

   transactions: Transaction[];
   transactionsFilter: Transaction[] = [];
   isExtendedTable = false;

   // Payment modal properties
   canUserRegisterPayment = State.user.permission.some(p => p.id === 31);
   showPaymentModal = false;
   processingPayment = false;
   payment_date: string = '';
   payment: BankPayment = {
      date: '',
      reference: '',
      amount: 0,
      description: '',
      bank: '',
      posId: '',
      posName: ''
   };

   // Payments table modal properties
   showPaymentsModal = false;
   loadingPayments = false;
   payments: Payment[] = [];

   constructor(private router: Router, private api: DataService, active_route: ActivatedRoute) {
      const today: Date = new Date(Date.now());
      today.setHours(0, 0, 0, 0);
      this.today = `${today.getFullYear()}-${pad_zeroes(today.getMonth() + 1)}-${pad_zeroes(today.getDate())}`;
      this.start_date = this.end_date = this.today;

      active_route.params.subscribe(params => {
         api.commerce_detailed(params.id, response => {
            if (response.succeeded) {
               this.commerce = response.data;
            } else error_toast(response.error.message);
         });
      });
   }

   back() { this.router.navigate(['transactions', 'points-of-sale']) }

   async query_transactions() {
      this.working = true;
      try {
         this.transactions = await this.api.transactions_by_commerce(this.commerce.id, this.start_date, this.end_date);
         this.working = false;
      } catch (e) {
         if (e instanceof Error) {
            error_toast(e.message);
            this.working = false;
         }
      }
   }

   change_enabled(enabled: boolean) {
      //this.working = true;
      this.api.active_commerce(this.commerce.id, enabled, response => {
         //this.working = false;
         if (response.succeeded) {
            success_toast('Comercio actualizado');
            this.commerce.enabled = enabled;
         } else error_toast(response.error.message);
      })
   }

   exportar_excel() {
      // const transactions = this.transactionsFilter.filter(t => t.response.code.endsWith('000') && !t.response.code.includes('C'));;
      const filas: (string | number)[][] = [];
      var headers: Array<string> = []

      if (this.isExtendedTable) {
         headers = [
            "Comercio",
            "Modalidad",
            "Tipo",
            "Cliente",
            "Monto",
            "Facturador",
            "Modo Pago",
            "Doc. Pago",
            "Respuesta",
            "Fecha",
            "Lote",
            "Secuencia",
            "Número Transacción"
         ];	
      } else {
         headers = [
            "Comercio",
            "Modalidad",
            "Tipo",
            "Cliente",
            "Monto",
            "Facturador",
            "Modo Pago",
            "Fecha",
            "ID transacción",
            "Estado",
            "Respuesta"
         ];	
      }


      this.transactionsFilter.forEach(t => filas.push(this.generarFila(t)));

      export_xlsx_file(this.commerce.name, headers, filas);
   }

   generarFila(t: Transaction): (string | number)[] {
      var fila: (string | number)[] = [];

      if (this.isExtendedTable) {
         fila = [
            t.commerce.description,
            t.prepaid ? "PREPAGO" : "POSPAGO",
            t.type.description,
            t.client,
            t.amount,
            t.invoicer.description,
            t.payment_method.description,
            t.payment_document,
            t.response.code,
            typeof t.date === 'string' ? t.date : formatDate(t.date, 'yyyy-MM-dd HH:mm:ss', 'es-DO'),
            t.lot,
            t.sequence,
            t.id
         ];
      } else {
         fila = [
            t.commerce.description,
            t.prepaid ? "PREPAGO" : "POSPAGO",
            t.type.description,
            t.client,
            t.amount,
            t.invoicer.description,
            t.payment_method.description,
            typeof t.date === 'string' ? t.date : formatDate(t.date, 'yyyy-MM-dd HH:mm:ss', 'es-DO'),
            t.id,
            t.status.id != 3 ? "EXITOSA" : "FALLIDA",
            t.response.code
         ];
      }

      return fila;
   }

   exportar_csv_total() {
      const transactions =  this.transactionsFilter.filter(t => t.response.code.endsWith('000') && !t.response.code.includes('C'));
      const invoicers = transactions.map(t => t.invoicer).distinct(i => i.id);
      const filas: (string | number)[][] = [];

      filas.push([this.commerce.name]);
      filas.push(["Pospago"]);
      filas.push(['Dia', ...invoicers.map(i => i.description), 'Total']);
      var pospaid_transactions = transactions.filter(t => !t.prepaid);
      this.generarFilas(pospaid_transactions.group(t => formatDate(t.date, 'yyyy-MM-dd', 'es-DO')),filas,invoicers);
      filas.push([""]);
      filas.push(["Prepago"]);
      filas.push(['Dia', ...invoicers.map(i => i.description), 'Total']);
      var prepaid_transactions = transactions.filter(t => t.prepaid);
      this.generarFilas(prepaid_transactions.group(t => formatDate(t.date, 'yyyy-MM-dd', 'es-DO')),filas,invoicers);
      export_text_file(this.commerce.name + '.csv', 'sep=;\n' + filas.map(celdas => celdas.map(c => typeof c === 'string'? `"${c}"` : c).join(';')).join('\n'));
   }

   generarFilas(daily: { key: string; items: Transaction[];}[],filas:(string | number)[][],invoicers:{id: number; description: string;}[]){
   var days = getDates( this.start_date, this.end_date)

    for( let day of days){
      var index =  daily.find( d => d.key  == day)
      if( index){
        filas.push([
          index.key,
          ...invoicers.map(i => Number(sum(index.items.filter(t => t.invoicer.id == i.id).map(t => t.amount)).toFixed(2))),
          Number(sum(index.items.map(t => t.amount)).toFixed(2))
        ]);
      }else {
        filas.push([
          day.toString(),
          ...invoicers.map(i => 0),
          0.00])
      }
    }
  }

  GetFilter(transations:Transaction[]){
    this.transactionsFilter = transations;
  }

  toogleExtendedTable(isExtended: boolean){
      this.isExtendedTable = isExtended;
      console.log(this.isExtendedTable);
  }

  // Payment registration methods
  openPaymentModal() {
      this.showPaymentModal = true;
      this.resetPaymentForm();
   }

   closePaymentModal() {
      this.showPaymentModal = false;
      this.resetPaymentForm();
   }

   resetPaymentForm() {
      this.payment = {
         date: this.today.toString(),
         reference: '',
         amount: 0,
         description: '',
         bank: '',
         posId: this.commerce.id.toString(),
         posName: this.commerce.name
      };
   }

   isPaymentValid(): boolean {
      return !!(this.payment.date && 
                this.payment.amount !== 0 && 
                this.payment.description.trim());
   }

   registerPayment() {
      if (!this.isPaymentValid()) {
         error_toast('Por favor complete todos los campos requeridos');
         return;
      }

      this.processingPayment = true;
      
      // Set POS information
      this.payment.posId = this.commerce.code;
      this.payment.posName = this.commerce.name;
      this.payment.reference = generateRandomString(25);
      const [year, month, day] = this.payment_date.split('-');
      this.payment.date = `${day}/${month}/${year}`;

      this.api.upload_payments([this.payment], response => {
         this.processingPayment = false;
         
         if (response.succeeded) {
            const result = response.data[0];
            if (result.success) {
               success_toast('Pago registrado exitosamente');
               this.closePaymentModal();
               // Optionally refresh commerce data to update balance
               this.refreshCommerceData();
            } else {
               error_toast(result.message || 'Error al registrar el pago');
            }
         } else {
            error_toast(response.error.message || 'Error al procesar el pago');
         }
      });
   }

   // Payments table methods
   openPaymentsModal() {
      this.showPaymentsModal = true;
      this.loadPayments();
   }

   closePaymentsModal() {
      this.showPaymentsModal = false;
      this.payments = [];
   }

   loadPayments() {
      this.loadingPayments = true;
      this.api.commerce_payments(this.commerce.code, response => {
         this.loadingPayments = false;
         
         if (response.succeeded) {
            this.payments = response.data;
         } else {
            error_toast(response.error.message || 'Error al cargar los pagos');
         }
      });
   }

   refreshCommerceData() {
      this.api.commerce_detailed(this.commerce.id + '', response => {
         if (response.succeeded) {
            this.commerce = response.data;
         }
      });
   }
}